import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class RecordUserContract extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/record/user/contract'
    super(store, path)
  }
}
